module.exports = __webpack_public_path__ + "static/media/DIFFLIEU.4b180f8f.png";